import { CryptoTransactionDetails } from 'BreetComponents';
import { useUsdWithdrawRequestContext } from 'BreetHooks';

const SendCryptoTransactionDetails = () => {
	const { formDataContextProps, walletInfoOptions, walletInfoData } = useUsdWithdrawRequestContext();

	return (
		<CryptoTransactionDetails
			formDataContextProps={formDataContextProps}
			walletInfoOptions={walletInfoOptions}
			walletInfoData={walletInfoData}
			currencySymbol='$'
			type='withdraw-usd'
		/>
	);
};

export default SendCryptoTransactionDetails;
